import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import Axios from "axios";
import $ from "jquery";

import LoadingSpinner from "../../ui/loadingSpinner";
import {baseNewImagesPath} from "../../assets";
import {IS_LIXIL_UI} from "../../../config";

const getPrivacyPolicyUrl = (fabricatorData) => {
  if (fabricatorData.isRebath) {
    return "rebathTerms.html"
  } else if (fabricatorData.isLowes) {
    return "lowesTerms.html"
  } else if (fabricatorData.isNhance) {
    return "nhanceTerms.html"
  }
  return "qcTerms.html"
}

const PrivacyPolicyTerms = (props) => {

  const {fabricatorData} = props;
  const [terms, setTerms] = useState(null);

  const privacyPolicyUrl = getPrivacyPolicyUrl(fabricatorData);

  useEffect(() => {
    const getTerms = async () => {
      const termsResponse = await Axios.get(baseNewImagesPath + "privacyPolicy/" + privacyPolicyUrl);
      if (termsResponse && termsResponse.data) {
        setTerms(termsResponse.data)
      }
    }
    getTerms();

    window.anchorScroll = (anchor) => {
      const $scrollableDiv = $(IS_LIXIL_UI ? ".grohe-lead__content" : ".user-popup-terms");
      const scrollToDiv = document.querySelector(`[data-anchor=${anchor}]`);
      // const scrollTop = $scrollToDiv ? $scrollToDiv.position().top - 50 : 0;
      const scrollTop = scrollToDiv ? scrollToDiv.offsetTop - 60 : 0;
      if (scrollTop) {
        $scrollableDiv.animate({scrollTop}, 1000);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return terms ? <div dangerouslySetInnerHTML={{ __html: terms }} /> : <LoadingSpinner/>
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData
  };
};

export default connect(mapStateToProps)(PrivacyPolicyTerms)
